import { Route, Switch } from "react-router-dom"

// Sets global variables and completes other setup steps
require("lib/technical/AppInit");

var Auth = require("lib/technical/RouteAuth");

var App = require("components/technical/App");

var HomePage = require("components/technical/HomePage");

var UpgradePage = require("components/users/teachers/upgrade/UpgradePage");
var ParentPage = require("components/users/parents/ParentPage");

var LoginPage = require("components/logins/LoginPage");
var SignoutPage = require("components/logins/SignoutPage");
var ForgotPasswordPage = require("components/logins/ForgotPasswordPage");
var ResetPasswordPage = require("components/logins/ResetPasswordPage");

var OwlShopPage = require("components/avatars/OwlShopPage");
var ClozePage = require("components/cloze/ClozePage");

var PicksPage = require("components/reading/picks/PicksPage");
var ActivitiesPage = require("components/writing/activities/ActivitiesPage");

var StudentParentsPage = require("components/users/parents/StudentParentsPage");

var ActivityPage = require("components/writing/activities/ActivityPage");
var StudentActivitiesPage = require("components/writing/activities/StudentActivitiesPage");
var NewResponsePage = require("components/writing/responses/NewResponsePage");

var ResponsePage = require("components/writing/responses/ResponsePage");

var NewAnswerPage = require("components/writing/answers/NewAnswerPage");

var QuestionBuilderPage = require("components/writing/answers/QuestionBuilderPage");

var QuizPage = require("components/writing/quizzes/QuizPage");
var ContestsPage = require("components/org/contests/ContestsPage");
var ClassResultsPage = require("components/data/ClassResultsPage");

var ClassPage = require("components/org/student_lists/ClassPage");
var MyShelfPage = require("components/reading/shelves/MyShelfPage");

var AdminRosteringPage = require("components/org/roster/AdminRosteringPage");
var RosterPage = require("components/org/roster/RosterPage");

var TutorialsPage = require("components/users/teachers/tutorials/TutorialsPage");

var DataPage = require("components/data/DataPage");
var TextQuestionsPage = require("components/writing/questions/TextQuestionsPage");

var InsightsPage = require("components/data/TeacherInsightsPage");
var MaintenancePage = require("components/technical/MaintenancePage");
var ErrorPage = require("components/technical/ErrorPage");
var RedirectPage = require("components/technical/RedirectPage");
var ScratchPage = require("components/technical/ScratchPage");

var SettingsPage = require("components/users/teachers/SettingsPage");

var DataRouting = require("lib/routing/DataRouting");
var OrgActivityRouting = require("lib/routing/OrgActivityRouting");
var AdminRosterRouting = require("lib/routing/AdminRosterRouting")
var RosterRouting = require("lib/routing/RosterRouting");
var ContestsRouting = require("lib/routing/ContestsRouting");
var ClassResultsRouting = require("lib/routing/ClassResultsRouting");
var ClassPageRouting = require("lib/routing/ClassPageRouting");
var MyShelfRouting = require("lib/routing/MyShelfRouting");
var OwlShopRouting = require("lib/routing/OwlShopRouting");
var SettingsRouting = require("lib/routing/SettingsRouting");
var ActivitiesPageRouting = require("lib/routing/ActivitiesPageRouting");


module.exports = (
	<App>
		<Switch>
			<Route path="/login" 				component={ Auth.LoggedOut(LoginPage) } />
			<Route path="/forgot_password" 		component={ Auth.LoggedOut(ForgotPasswordPage) } />

			<Route exact path="/" 				component={ Auth.AllAccess(HomePage) } />
			<Route path={ OrgActivityRouting.PATH }	component={ Auth.AllAccess(HomePage) } />

			<Route path="/responses/new" 		component={ Auth.LoggedIn(NewResponsePage) } />
			<Route path="/responses/:id" 		component={ Auth.LoggedIn(ResponsePage) } />


			<Route path="/answers/new" 			component={ Auth.Students(NewAnswerPage) } />
			<Route path="/reviews/new" 			component={ Auth.Students(NewAnswerPage) } />
			<Route path="/question_builder/new" component={ Auth.Students(QuestionBuilderPage) } />
			<Route path="/activity_center" 		component={ Auth.Students(StudentActivitiesPage) } />
			<Route path={ OwlShopRouting.PATH } component={ Auth.Students(OwlShopPage) } />
			<Route path="/quiz" 				component={ Auth.Students(QuizPage) } />
			<Route path="/cloze" 				component={ Auth.Students(ClozePage) } />
			<Route path={ MyShelfRouting.PATH }	component={ Auth.Students(MyShelfPage) } />

			<Route path="/insights"				component={ Auth.TeachersAndSchoolAdmins(InsightsPage) } />
			<Route path="/learning_series" 		component={ Auth.TeachersAndSchoolAdmins(TutorialsPage) } />

			<Route path={ ActivitiesPageRouting.PATH } 			component={ Auth.Teachers(ActivitiesPage) } />
			<Route path="/activities/:id" 		component={ Auth.Teachers(ActivityPage) } />
			<Route path="/picks" 				component={ Auth.Teachers(PicksPage) } />

			<Route path={ ClassPageRouting.PATH } component={ Auth.LoggedIn(ClassPage) } />


			<Route path={ RosterRouting.PATH }	component={ Auth.TeachersAndSchoolAdmins(RosterPage) } />
			<Route path={ DataRouting.PATH } 	component={ Auth.TeachersAndSchoolAdmins(DataPage) } />
			<Route path={ AdminRosterRouting.PATH }	component={ Auth.TeachersAndSchoolAdmins(AdminRosteringPage) } />			

			<Route path={ ContestsRouting.PATH }		component={ Auth.AllAccess(ContestsPage) } />
			<Route path={ ClassResultsRouting.PATH }	component={ Auth.AllAccess(ClassResultsPage) } />

			<Route path={ SettingsRouting.PATH }		component={ Auth.AllAccess(SettingsPage) } />

			<Route path="/questions/:text_id?" 	component={ Auth.TeachersAndSchoolAdmins(TextQuestionsPage) } />

			<Route path="/upgrade" 				component={ Auth.Teachers(UpgradePage) } />

			<Route path="/redirect" 			component={ Auth.AllAccess(RedirectPage) } />
			<Route path="/maintenance"	 		component={ Auth.AllAccess(MaintenancePage) } />
			<Route path="/error"	 			component={ Auth.AllAccess(ErrorPage) } />
			<Route path="/reset_password" 		component={ Auth.AllAccess(ResetPasswordPage) } />
			<Route path="/signout" 				component={ Auth.AllAccess(SignoutPage) } />
			<Route path="/student_parents" 		component={ Auth.TeachersAndSchoolAdmins(StudentParentsPage) } />
			<Route path="/parents/:id" 			component={ Auth.AllAccess(ParentPage) } />

			<Route path="/scratch" 				component={ Auth.DevelopmentAccess(ScratchPage) } />
		</Switch>
	</App>
);



// WEBPACK FOOTER //
// ./modules/routes.js